import store from "../redux/store";
import Web3 from "web3";
import unipair_abi from "../abis/IUniswapV2Pair.json";

import {makeBatchRequest} from "./promisify";
import {updatePrices, updateTotals} from "../redux/slices/coineusSlice";
import uni_pair_abi from "../abis/IUniswapV2Pair.json";

export default function getPairPrices() {
    const _store = store.getState();
    const {pairs, rpc} = _store.coineus;

    getFUSE(pairs, rpc.fuse);
}

function getFUSE(pairs, rpc) {

    //FUSE
    const web3 = new Web3(rpc);
    const fusd_fuse = new web3.eth.Contract(unipair_abi, pairs.fUSDFUSEpair);
    const ceus_fuse = new web3.eth.Contract(unipair_abi, pairs.CEUSFUSEpair);
    const ceus_lit = new web3.eth.Contract(unipair_abi, pairs.CEUSLITPair);
    const ceus_lit_contract = new web3.eth.Contract(uni_pair_abi, "0x87440F829E7ED808599749630555080917c4b3D9") //CEUS/LIT LP
    const ceus_fuse_contract = new web3.eth.Contract(uni_pair_abi, "0x3b46eFdd411cc0Db43f1BE7853727e18Cce8b85b") //CEUS/FUSE LP
    const fuse_lit_contract = new web3.eth.Contract(uni_pair_abi, "0x1A77BAea67C346cE17486b078a3c3F53a99A9Fcc") //CEUS/FUSE LP
    const fvksrg_fuse_contract = new web3.eth.Contract(uni_pair_abi, "0xA9c312E6DAC0EC56C6A8CB338e9121c6349D9beD") //FVKSRG/FUSE LP
    const fvksrg_ceus_contract = new web3.eth.Contract(uni_pair_abi, "0xB6850233c408Bbf58c3B2beC945394114cB08Fd0") //FVKSRG/CEUS LP
    const foo_wfuse_contract = new web3.eth.Contract(uni_pair_abi, "0x4f47a2c360266230795CFBca80b7C89EdA52Cd52") //WFUSE/FOO LP

    const calls = [
        fusd_fuse.methods.getReserves().call,
        ceus_fuse.methods.getReserves().call,
        ceus_lit.methods.getReserves().call,

        ceus_lit_contract.methods.getReserves().call,
        ceus_lit_contract.methods.totalSupply().call,

        ceus_fuse_contract.methods.getReserves().call,
        ceus_fuse_contract.methods.totalSupply().call,

        fuse_lit_contract.methods.getReserves().call,
        fuse_lit_contract.methods.totalSupply().call,

        fvksrg_fuse_contract.methods.getReserves().call,
        fvksrg_fuse_contract.methods.totalSupply().call,

        fvksrg_ceus_contract.methods.getReserves().call,
        fvksrg_ceus_contract.methods.totalSupply().call,

        foo_wfuse_contract.methods.getReserves().call,
        foo_wfuse_contract.methods.totalSupply().call,
    ]

    makeBatchRequest(web3, calls, "get_prices getFUSE()")
        .then(resp => {
            const [
                fusd_fuse_reserves,
                ceus_fuse_reserves,
                ceus_lit_reserves,

                ceus_lit_lp_reserves,
                ceus_lit_lp_totalSupply,

                ceus_wfuse_lp_reserves,
                ceus_wfuse_lp_totalSupply,

                fuse_lit_reserves,
                fuse_lit_totalSupply,

                fvksrg_fuse_reserves,
                fvksrg_fuse_totalSupply,

                fvksrg_ceus_reserves,
                fvksrg_ceus_totalSupply,

                foo_wfuse_reserves,
                foo_wfuse_totalSupply
            ] = resp

            //FUSE
            store.dispatch(updatePrices({
                chain: 'fuse',
                contract_address: 'native',
                price: {
                    inUSD: fusd_fuse_reserves.reserve1/fusd_fuse_reserves.reserve0,
                    inFuse: 1
                }
            }));

            //WFUSE
            store.dispatch(updatePrices({
                chain: 'fuse',
                contract_address: '0x0BE9e53fd7EDaC9F859882AfdDa116645287C629',
                price: {
                    inUSD: fusd_fuse_reserves.reserve1/fusd_fuse_reserves.reserve0,
                    inFuse: 1
                }
            }));

            //FUSD
            store.dispatch(updatePrices({
                chain: 'fuse',
                contract_address: '0xCE86a1cf3cFf48139598De6bf9B1dF2E0f79F86F',
                price: {
                    inUSD: (fusd_fuse_reserves.reserve0/fusd_fuse_reserves.reserve1) * (fusd_fuse_reserves.reserve1/fusd_fuse_reserves.reserve0),
                    inFuse: fusd_fuse_reserves.reserve0/fusd_fuse_reserves.reserve1
                }
            }));

            //CEUS
            const ceus_price_usd = ceus_fuse_reserves.reserve0/ceus_fuse_reserves.reserve1 * fusd_fuse_reserves.reserve1/fusd_fuse_reserves.reserve0;
            store.dispatch(updatePrices({
                chain: 'fuse',
                contract_address: '0x4e69Ae0CD024754655b4eF74F24A8DCB39Ba07e8',
                price: {
                    inFuse: ceus_fuse_reserves.reserve0/ceus_fuse_reserves.reserve1,
                    inUSD: ceus_price_usd
                }
            }));

            //CEUSONE
            store.dispatch(updatePrices({
                chain: 'fuse',
                contract_address: '0xE27431FACb1F093BA164c9F86B3f484b39ad54CC',
                price: {
                    inFuse: ceus_fuse_reserves.reserve0/ceus_fuse_reserves.reserve1,
                    inUSD: ceus_price_usd
                }
            }));

            //LIT
            store.dispatch(updatePrices({
                chain: 'fuse',
                contract_address: '0xF2C6C1AA2bf8ec40F564Ea8A483F64907ea37A3F',
                price: {
                    inFuse: ceus_fuse_reserves.reserve0/ceus_fuse_reserves.reserve1,
                    inUSD: ceus_lit_reserves.reserve0/ceus_lit_reserves.reserve1 * (ceus_price_usd),
                    inBase: ceus_lit_reserves.reserve0/ceus_lit_reserves.reserve1
                }
            }));

            //FVKSRG
            store.dispatch(updatePrices({
                chain: 'fuse',
                contract_address: '0xa28a758619ba32B11F8D55eB6C0E1C7E5929bF61',
                price: {
                    inFuse: fvksrg_fuse_reserves.reserve0/fvksrg_fuse_reserves.reserve1,
                    inUSD: fvksrg_fuse_reserves.reserve0/fvksrg_fuse_reserves.reserve1 * fusd_fuse_reserves.reserve1/fusd_fuse_reserves.reserve0,
                    inBase: fvksrg_ceus_reserves.reserve0/fvksrg_ceus_reserves.reserve1
                }
            }));

            // TODO: LADY/FOO
            //FOO
            store.dispatch(updatePrices({
                chain: 'fuse',
                contract_address: '0x74616164eB1892ceC5fa553D45b3e5D6dF7BC7b9',
                price: {
                    inFuse: 0,
                    inUSD: 0,
                    inBase: 0
                }
            }));

            // CEUS/LIT LP
            let total = (ceus_lit_lp_reserves.reserve0 / (10**18)) * ceus_price_usd;
            store.dispatch(updatePrices({
                chain: 'fuse',
                contract_address: '0x87440F829E7ED808599749630555080917c4b3D9',
                price: {
                    // inUSD: 0
                    inUSD: (total*2) / (ceus_lit_lp_totalSupply / (10**18))
                }
            }));

            // FUSE/CEUS LP
            let total2 = (ceus_wfuse_lp_reserves.reserve0 / (10**18)) * fusd_fuse_reserves.reserve1/fusd_fuse_reserves.reserve0;
            store.dispatch(updatePrices({
                chain: 'fuse',
                contract_address: '0x3b46eFdd411cc0Db43f1BE7853727e18Cce8b85b',
                price: {
                    // inUSD: 0
                    inUSD: (total2*2) / (ceus_wfuse_lp_totalSupply / (10**18))
                }
            }));

            // FUSE/CEUS LP
            let total3 = (fuse_lit_reserves.reserve0 / (10**18)) * fusd_fuse_reserves.reserve1/fusd_fuse_reserves.reserve0;
            store.dispatch(updatePrices({
                chain: 'fuse',
                contract_address: '0x1A77BAea67C346cE17486b078a3c3F53a99A9Fcc',
                price: {
                    // inUSD: 0
                    inUSD: (total3*2) / (fuse_lit_totalSupply / (10**18))
                }
            }));

            // FVKSRG/CEUS LP
            let total6 = (fvksrg_ceus_reserves.reserve0 / (10**18)) * ceus_price_usd;
            store.dispatch(updatePrices({
                chain: 'fuse',
                contract_address: '0xB6850233c408Bbf58c3B2beC945394114cB08Fd0',
                price: {
                    inUSD: (total6*2) / (fvksrg_ceus_totalSupply / (10**18))
                }
            }));

            // FVKSRG/FUSE LP
            let total7 = (fvksrg_fuse_reserves.reserve0 / (10**18)) * fusd_fuse_reserves.reserve1/fusd_fuse_reserves.reserve0;
            store.dispatch(updatePrices({
                chain: 'fuse',
                contract_address: '0xA9c312E6DAC0EC56C6A8CB338e9121c6349D9beD',
                price: {
                    inUSD: (total7*2) / (fvksrg_fuse_totalSupply / (10**18))
                }
            }));

            // FOO/FUSE LP
            let total10 = (foo_wfuse_reserves.reserve0 / (10**18)) * fusd_fuse_reserves.reserve1/fusd_fuse_reserves.reserve0;
            store.dispatch(updatePrices({
                chain: 'fuse',
                contract_address: '0x4f47a2c360266230795CFBca80b7C89EdA52Cd52',
                price: {
                    inUSD: (total10*2) / (foo_wfuse_totalSupply / (10**18))
                }
            }));

            store.dispatch(updateTotals('fuse'));
        });
}

